<!-- 主入口 -->
<template>
    <component :is="HomeComponent" v-if="HomeComponent" />
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import PcHome from './pc/home/index.vue';
import PhoneHome from './phone/home/index.vue'; 
import PadHome from './pad/home/index.vue';     
import { ElMessage } from 'element-plus';

// 2. 定义设备类型
type DeviceType = 'pc' | 'phone' | 'pad';

// 3. 检测设备逻辑
const getDeviceType = (): DeviceType => {
  const width = window.innerWidth;
  if (width < 768) {
    return 'phone';
  } else if (width < 1024) {
    return 'pad';
  } else {
    return 'pc';
  }
};

// 【关键修改】初始化时直接获取设备类型，避免初始值为 unknown
const deviceType = ref<DeviceType>(getDeviceType());

const checkDevice = () => {
  deviceType.value = getDeviceType();
};

onMounted(() => {
  // 再次检查以防万一，或者处理 SSR  hydration  mismatch (如果涉及 SSR)
  checkDevice(); 
  window.addEventListener('resize', checkDevice);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkDevice);
});

const HomeComponent = computed(() => {
  switch (deviceType.value) {
    case 'pc': 
      return PcHome;
    case 'phone': 
      return PhoneHome;
    case 'pad': 
      return PadHome;
    default: 
      // 理论上不会走到这里，因为 getDeviceType 总是返回有效值
      // 如果必须保留，建议不要在这里弹 Message，而是返回 null 并在 watch 中处理异常
      console.warn('Unknown device type detected');
      return null; 
  }
});

</script>

<style>
</style>